module.exports = __webpack_public_path__ + "static/media/tettigonia_cantans_006_APA.9b9c94fd.png";